const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransplantation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12.401,18.203 c0.004,0.041,0.109,0.852-0.061,1.92c-0.205-0.104-0.42-0.193-0.645-0.27c0.112-0.846,0.044-1.49,0.038-1.555 c-0.007-0.035-0.011-0.07-0.017-0.107l-0.005-0.01c-1.313-3.375-4.275-4.515-4.305-4.525c-0.09-0.035-0.157-0.1-0.192-0.181 c-0.034-0.079-0.04-0.168-0.004-0.254c0.063-0.174,0.256-0.262,0.431-0.198c0.111,0.041,2.35,0.897,3.909,3.349 c-0.066-3.608,1.487-5.849,1.565-5.957c0.109-0.152,0.317-0.188,0.47-0.081c0.152,0.108,0.186,0.317,0.08,0.47 c-0.021,0.029-2.032,2.947-1.267,7.386L12.401,18.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCF03",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M11.407,11.908l-0.876,0.171l-2.244,0.84 c0,0-0.584,0.95-0.591,1.074c-0.006,0.124-0.273,0.99-0.256,1.036c0.018,0.045,0.116,0.775,0.116,0.775s1.209,1.463,2.16,0.097 c0,0,1.418-2.116,1.714-3.932"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M19.153,11.375c0,0-2.3-4.96,3.018-6.597 c0,0,8.182-1.791,8.387,9.563c0,0-0.563,12.375-8.848,10.175c0,0-4.143-0.818-2.453-5.727c0,0,1.904-4.897-0.039-7.3L19.153,11.375 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M22.583,14.804 c2.871,0.447,4.553,2.156,4.635,2.242c0.129,0.135,0.125,0.348-0.01,0.475c-0.064,0.065-0.148,0.098-0.234,0.098 c-0.088,0-0.174-0.035-0.242-0.104c-0.021-0.023-2.25-2.281-5.867-2.135h-0.012c-0.035,0.009-0.069,0.019-0.105,0.028 c-0.065,0.021-0.747,0.233-1.529,0.728c1.069,0.087,2.086,0.529,2.984,1.306c0.893,0.771,1.354,1.598,1.373,1.634 c0.091,0.162,0.031,0.365-0.131,0.457c-0.053,0.027-0.108,0.043-0.164,0.043c-0.118,0-0.233-0.063-0.295-0.174 c-0.004-0.009-0.433-0.771-1.241-1.464c-1.034-0.887-2.19-1.26-3.435-1.111c-0.971,0.889-1.511,1.979-1.608,3.254v9.563h-0.674 v-9.575l0.001-0.023c0.122-1.669,0.949-3.113,2.389-4.178c1.076-0.795,2.105-1.095,2.15-1.109l0.012-0.002 c4.373-1.075,6.242-4.086,6.26-4.117c0.098-0.158,0.303-0.211,0.463-0.115c0.16,0.097,0.211,0.303,0.115,0.463 C27.349,11.101,25.917,13.42,22.583,14.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M23.435,11.37 c-1.248,1.26-3.315,2.474-6.145,3.607l-0.021,0.009c-0.025,0.007-2.476,0.857-2.323,5.94v8.715h-0.674v-8.7 c-0.162-5.443,2.533-6.508,2.776-6.594c0.283-0.113,0.555-0.227,0.814-0.339c-1.034-0.537-1.485-1.705-1.507-1.765 c-0.065-0.175,0.023-0.369,0.197-0.435c0.174-0.065,0.368,0.023,0.434,0.197c0.006,0.015,0.571,1.469,1.8,1.586 c4.339-2.258,4.854-3.748,4.854-3.748c0.297-0.76,1.313-0.609,0.605,0.5C24.075,10.612,23.833,10.967,23.435,11.37z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M2.247,16.733c0,0-0.277-1.279-0.412-2.974 C1.66,11.554,1.725,8.638,2.956,6.908c0,0,1.756-2.664,6.438-2.016c0,0,1.334,0.108,3.408-1.174c0,0,4.721-2.786,4.59,0.613 c0,0-0.148,5.349-5.406,7.568c0,0-1.193,0.58-2.45,1.821c-2.469,2.058-1.779,1.558-3.234,2.635 C6.3,16.355,2.656,19.674,2.247,16.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8398"
    },
    d: "M9.756,13.317c0.585-1.281,0.073-2.603,0.073-2.603c-0.771-2.264,0.658-3.979,0.658-3.979 c0.838-1.531-0.111-1.786-0.111-1.786l1.56-0.565c0,0,1.275,0.292,0.248,1.867c0,0-1.431,1.716-0.66,3.979 c0,0-0.041,0.758-0.083,1.71L9.756,13.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M1.771,11.49 c0,0,0.63-2.832,2.987-3.54"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M7.186,15.67 c0,0-1.639,0.813-3.372-0.472"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M10.134,4.825c0,0,1.23,0.362,0.203,1.936 c0,0-1.43,1.716-0.659,3.979c0,0,0.709,2.109-0.244,3.072"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M11.84,4.245c0,0,1.219,0.457,0.193,2.031 c0,0-1.43,1.716-0.66,3.98c0,0,0.216,0.935,0.174,1.886"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M9.452,19.508 c0,2.358,1.911,4.271,4.273,4.271c2.36,0,4.273-1.913,4.273-4.271c0-2.362-1.913-4.274-4.273-4.274 C11.363,15.233,9.452,17.146,9.452,19.508z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M11.35,20.107 c0.269,1.063,1.229,1.848,2.375,1.848c1.142,0,2.104-0.785,2.373-1.844"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.084,18.851 c-0.286-1.033-1.235-1.792-2.359-1.792c-1.126,0-2.074,0.759-2.361,1.792"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2C355E"
    },
    points: "15.355,18.771 16.084,19.499 16.814,18.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2C355E"
    },
    points: "12.093,20.229 11.364,19.499 10.635,20.229  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransplantation);
export default __webpack_public_path__ + "static/media/transplantation.436bf097466bcc680c27544a1c13a102.svg";
export { ForwardRef as ReactComponent };